import React from 'react';

// Utils
import { Box, Type, LoadingSpinner } from '@nerdwallet/currency';

// CSS
import style from './city-loading.module.less';

const CityLoading = (): JSX.Element => {
  const loadingText = 'Loading city data - coming right up!';

  return (
    <Box
      className={style.loading}
      paddingY={{ mobile: 5 }}
      alignItems="center"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      width={{ desktop: 30 }}
      marginX="auto"
      marginY={{ mobile: 4 }}
    >
      <LoadingSpinner size={64} />
      <Box padding={3} />
      <Type size={4} bold color="green" align="center">
        {loadingText}
      </Type>
    </Box>
  );
};

CityLoading.displayName = 'CityLoading';

export default CityLoading;
